import store from 'utils/store';
import {hasPrivilege, isTeamManager, PLAYLIST_WRITE} from 'utils/privileges';
import config from 'utils/config';

export function isTeamManagerAndNotAdmin({domain_id, ownerTeamId}) {
	if (!ownerTeamId) {
		return false;
	}

	if (hasPrivilege(PLAYLIST_WRITE)) {
		return false;
	}

	const isSharedPlaylist = domain_id && +store('domainId') !== +domain_id;
	if (isSharedPlaylist) {
		return false;
	}

	const doesUserManageTeamPlaylist =
		config.enableTeamPlaylists && ownerTeamId && isTeamManager(ownerTeamId);

	return doesUserManageTeamPlaylist;
}
